<script lang="ts" module>
  export type ArtistInfo = {
    Artist?: string;
    Material?: string;
    Product?: string;
  };
</script>

<script lang="ts">
  import AlternateEmail from '@athena-lib/Icons/AlternateEmail.svelte';
  import Paragraph from '@athena-lib/Text/Paragraph/Paragraph.svelte';
  import clsx from 'clsx';

  const { metaData, class: className = '' }: { metaData: ArtistInfo; class: string } = $props();

  let artistNameExpanded = $state(false);

  const artistInfo = $derived.by((): string => {
    const { Artist, Material, Product } = metaData;
    if (!Artist) {
      return '';
    }

    return [Artist, Material, Product].filter(Boolean).join(' - ');
  });

  const toggleExpandArtistName = () => {
    artistNameExpanded = !artistNameExpanded;
  };
</script>

<div>
  {#if metaData.Artist !== ''}
    <div class="relative">
      <div
        class={clsx(
          'absolute left-2 w-auto items-center rounded-full bg-st-gray-200 p-1 lg:p-2',
          className,
        )}
      >
        <div class="flex">
          <button type="button" onclick={() => toggleExpandArtistName()}>
            <AlternateEmail sizeClass="h-6 w-6" />
          </button>
          {#if artistNameExpanded}
            <Paragraph color="dark" class="content-center px-3" italic={true}>
              {artistInfo}
            </Paragraph>
          {/if}
        </div>
      </div>
    </div>
  {/if}
</div>
